import uuidv4 from "uuid/v4";

export default class UuidGenerator {
    static v4(): string {
        return uuidv4();
    }
}


// WEBPACK FOOTER //
// ./src/common/uuid/UuidGenerator.ts